import { TRIANGLE_DEFAULTS } from '../shapes/triangle/triangle.model';
import { RECTANGLE_DEFAULTS } from '../shapes/rectangle/rectangle.model';
import { SQUARE_DEFAULTS } from '../shapes/square/square.model';
import { PARALLELOGRAM_DEFAULTS } from '../shapes/parallelogram/parallelogram.model';
import { RHOMBUS_DEFAULTS } from '../shapes/rhombus/rhombus.model';
import { TRAPEZOID_DEFAULTS } from '../shapes/trapezoid/trapezoid.model';
import { CIRCLE_DEFAULTS } from '../shapes/circle/circle.model';
import { ARC_DEFAULTS } from '../shapes/arc/arc.model';
import { POINT_GEO_DEFAULTS, LINE_GEO_DEFAULTS, POLYGON_GEO_DEFAULTS } from '../shapes/primitives/primitives.model';
import type { GeometryShapeTheme } from './geometry-shape-style.model';

/**
 * Default geometry shape theme — maps element type to its display defaults.
 *
 * These defaults encode the "colored" variant. When `geometryConfig.shape.coloring`
 * is false, the resolution function neutralizes colors to 'neutral'.
 */
export const DEFAULT_GEOMETRY_SHAPE_THEME: GeometryShapeTheme = {
  Triangle: TRIANGLE_DEFAULTS,
  Rectangle: RECTANGLE_DEFAULTS,
  Square: SQUARE_DEFAULTS,
  Parallelogram: PARALLELOGRAM_DEFAULTS,
  Rhombus: RHOMBUS_DEFAULTS,
  Trapezoid: TRAPEZOID_DEFAULTS,
  Circle: CIRCLE_DEFAULTS,
  Arc: ARC_DEFAULTS,
  Point: POINT_GEO_DEFAULTS,
  Line: LINE_GEO_DEFAULTS,
  Polygon: POLYGON_GEO_DEFAULTS,
};
